//
import React, { Fragment } from 'react';
import { Text, Box, lessThan } from 'localmed-core';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import CovidIcon from '../../../legacyCore/icons/CovidIcon';
import Button from '../../../shared/components/Button';
import { TYPES } from './constants';

const Wrapper = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3em;
    overflow: hidden;
    background-color: ${theme.colors.oranges[50]};
    color: ${theme.colors.orange};
    padding: ${theme.space.xs};
  `,
  lessThan(
    'md',
    ({ theme }) => css`
      font-size: ${theme.fontSizes.sm};
      line-height: ${theme.lineHeights.text};
      min-height: 3em;
      height: auto;
      overflow: initial;
    `
  )
);

const TextWrapper = styled('span')(
  ({ theme }) => css`
    display: flex;
    margin-left: ${theme.space.sm};
    justify-content: center;
    align-items: center;
    font-family: ${theme.fonts.heading};
  `,
  lessThan(
    'md',
    css`
      flex-wrap: wrap;
      justify-content: flex-start;
    `
  )
);

const StyledButton = styled(Button)(
  ({ theme }) => css`
    margin-left: ${theme.space.sm};
    color: ${theme.colors.orange};

    &:hover {
      color: ${theme.colors.white};
    }
  `
);

export default function AnnouncementBanner({ announcement }) {
  const { type, content, moreUrl } = announcement;
  const isCovidType = type === TYPES.COVID_19;
  return (
    <Wrapper>
      {isCovidType ? (
        <Fragment>
          <CovidIcon
            height="5em"
            width="5em"
            color="orange"
            opacity="20%"
            css={css`
              min-width: 5em;
              transform: initial;
            `}
          />
          <Box
            display="flex"
            alignItems="center"
            justifyContent={{ _: 'flex-start', md: 'center' }}
            flexWrap="wrap"
          >
            <TextWrapper>
              <Text fontWeight="bold" mr="xxs">
                Covid-19 Notice:
              </Text>

              <Text>{content}</Text>
            </TextWrapper>
            {moreUrl && (
              <StyledButton
                href={moreUrl}
                variant="outline"
                buttonColor="orange"
                size="sm"
                rel="noopener noreferrer"
                target="_blank"
              >
                View our Covid-19 Procedures
              </StyledButton>
            )}
          </Box>
        </Fragment>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
          <Text fontFamily="heading">{content}</Text>
          {moreUrl && (
            <StyledButton
              href={moreUrl}
              variant="outline"
              buttonColor="orange"
              size="sm"
              rel="noopener noreferrer"
              target="_blank"
            >
              Read More
            </StyledButton>
          )}
        </Box>
      )}
    </Wrapper>
  );
}
